/*
 * Helper: GTM dataLayer push
 * ---------------------------------------------------------------------------
 * Normalizes event payloads and pushes to window.dataLayer.
 */

/**
 * Push a normalized event to Google Tag Manager's dataLayer
 *
 * @param {Object} context - Vue context (access to $store, $variable, isMobile)
 * @param {string} eventName - GTM event name (e.g., 'filter_interaction',
 * 'nav_click')
 * @param {string} elementName - Name/identifier of the element
 *   triggering the event
 * @param {Object} extra - Additional event parameters to merge into the payload
 */

export function gtmPush(context, eventName, elementName, extra = {}) {
  try {
    const isMobile =
      (context && context.isMobile) ??
      (context && context.$store && context.$store.state &&
        context.$store.state.index && context.$store.state.index.screen &&
        context.$store.state.index.screen.mobile) ??
      false

    const getVar = key => {
      return context && typeof context.$variable === 'function' ? context.$variable(key) : null
    }
    const customerEnabled = Boolean(getVar('customer.enabled'))

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: eventName,
      page: { url: window.location.href, name: document.title },
      element: { name: elementName },
      device: isMobile ? 'mobile' : 'desktop',
      customer: {
        logged_in: customerEnabled,
      },
      timestamp: new Date().toISOString(),
      ...extra,
    })
  } catch (error) {
    // no-op
  }
}
